import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function LevelOrderPaid({
  total,
}: {
  total: number | undefined;
  currency: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-6">
      {typeof total === 'number' && (
        <div className="mt-4 flex flex-col items-center">
          <FontAwesomeIcon
            className="h-20 text-green-400"
            icon={faCheckCircle}
          />
        </div>
      )}
    </div>
  );
}
